exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.amap-demo[data-v-ff2a2352] {\r\n  margin: auto;\r\n  height: 220px;\n}\n.juan[data-v-ff2a2352] {\r\n  position: absolute;\r\n  right: 13px;\r\n  margin-top: 18px;\r\n  z-index: 999;\n}\n.juan img[data-v-ff2a2352] {\r\n  width: 45px;\r\n  height: 45px;\n}\r\n", ""]);

// exports
